export default __webpack_public_path__ + "static/media/pentagon5.44d13033.png";